<template>
  <b-modal
    v-model="showModal"
    size="xl"
    centered
    scrollable
    modal-class="modal-edit-action-item"
    body-class="row modal-edit-action-item__body"
    footer-class="no-gutters"
    header-class="no-gutters align-items-center"
    @ok="submitActionItem"
  >
    <template #modal-header="{ close }">
      <div class="col-auto mr-auto">
        <div class="h6 my-0">Editar ação</div>
      </div>
      <select-status class="col-auto" v-model="form.status" size="sm" pill />
      <div class="col-auto">
        <b-button @click="close" variant="link-dark">
          <b-icon icon="x"></b-icon>
        </b-button>
      </div>
    </template>
    <div class="col-12">
      <form-list-actions v-model="form" :grid-mode="true" />
    </div>
    <template #modal-footer="{ cancel, ok }">
      <div class="col-auto ml-auto">
        <b-button @click="cancel" class="mr-2">Cancelar</b-button>
        <b-button @click="ok" variant="primary">Salvar</b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import FormListActions from "@/modules/action_plans/components/Form/FormListActions.vue";
import SelectStatus from "@/modules/action_plans/components/Form/SelectStatus.vue";
import { mapActions } from "vuex";

export default {
  components: { FormListActions, SelectStatus },
  data: () => ({
    showModal: false,
    form: {},
    isEditingPlan: false,
  }),
  methods: {
    ...mapActions("action_plans", ["ActionSavePlanItem", "ActionSave"]),
    show(item) {
      this.isEditingPlan = !!(item && item.name && !item.what && (item.model_id != null || item.model_type));
      const whoId = item.who_id ?? item.model_id ?? item.whoModel?.id ?? item.who_model?.id ?? null;
      const rawType = item.who_type ?? item.model_type ?? "";
      const whoType = this.normalizeWhoType(rawType);
      this.form = {
        ...item,
        what: item.what ?? item.name ?? "",
        who_id: whoId,
        who_type: whoType,
        status: item.status || item.prazo?.status || "",
        action_plans_how_much: item.action_plans_how_much ?? item.action_plan_how_much ?? [],
      };
      this.showModal = true;
    },
    normalizeWhoType(rawType) {
      const t = String(rawType || "").toLowerCase();
      if (t.includes("organizationalstructure") || t === "organizational_structure") return "organizational_structure";
      if (t.includes("physicalperson") || t === "physical_person") return "physical_person";
      return "organizational_structure";
    },
    async submitActionItem(bvModalEvt) {
      bvModalEvt.preventDefault();

      try {
        if (this.isEditingPlan) {
          const payload = {
            ...this.form,
            name: this.form.what ?? this.form.name,
            model_id: this.form.who_id ?? this.form.model_id,
            model_type: this.form.who_type ?? this.form.model_type,
          };
          await this.ActionSave(payload);
        } else {
          await this.ActionSavePlanItem(this.form);
        }
        this.$notifications.addNotification({
          message: "Registro atualizado com sucesso",
          type: "success",
        });
        this.showModal = false;
        this.$emit("saved");
      } catch (error) {
        this.$notifications.addNotification({
          message: "Erro ao salvar",
          type: "danger",
        });
      }
    },
  },
};
</script>

<style lang="scss">
/* A prop `modal-class` do b-modal aplica esta classe no elemento raiz `.modal`,
   então os seletores abaixo descem a partir dele para alcançar
   `.modal-dialog`, `.modal-content` e `.modal-body`.
   Com centered + scrollable, o Bootstrap 4 zera o max-height do .modal-content
   em certos casos, então reforçamos aqui para garantir a rolagem vertical. */
.modal-edit-action-item {
  .modal-dialog.modal-dialog-centered.modal-dialog-scrollable .modal-content {
    /* Fixamos a altura (em vez de apenas max-height) para que o .modal-body
       tenha SEMPRE uma altura limitada e a barra de rolagem fique visível,
       independentemente do tamanho do conteúdo. */
    height: calc(100vh - 1rem);
    max-height: calc(100vh - 1rem);
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }

  @media (min-width: 576px) {
    .modal-dialog.modal-dialog-centered.modal-dialog-scrollable .modal-content {
      height: calc(100vh - 3.5rem);
      max-height: calc(100vh - 3.5rem);
    }
  }

  .modal-body.modal-edit-action-item__body {
    min-height: 0;
    /* O Bootstrap aplica `margin: 0 -15px` na classe `.row` usada no body.
       Isso empurra as laterais do body 15px para fora do `.modal-content`,
       fazendo a barra de rolagem (na borda direita do body) ser recortada
       pelo `overflow: hidden` do `.modal-content`. Zeramos a margem para
       que a barra fique dentro do modal. */
    margin-right: 0;
    margin-left: 0;
    /* Ocupa toda a altura disponível entre header e footer, garantindo que
       o track da barra apareça de ponta a ponta mesmo com pouco conteúdo. */
    flex: 1 1 auto;
    /* `scroll` força a barra a ficar sempre visível, permitindo que o usuário
       arraste o thumb mesmo sem depender da rodinha do mouse. */
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
    /* Firefox: auto costuma ser mais largo que thin */
    scrollbar-width: auto;
    scrollbar-color: #6d7786 #e9edf2;

    &::-webkit-scrollbar {
      width: 18px;
    }

    &::-webkit-scrollbar-track {
      background: #e9edf2;
      border-radius: 8px;
      box-shadow: inset 0 0 0 1px #d3d9e0;
    }

    &::-webkit-scrollbar-thumb {
      background: #6d7786;
      border-radius: 8px;
      border: 3px solid #e9edf2;
      min-height: 40px;
    }

    &::-webkit-scrollbar-thumb:hover {
      background: #4a5260;
    }

    &::-webkit-scrollbar-thumb:active {
      background: #2f3540;
    }
  }
}
</style>
